import { useCallback, useState } from 'react';
import Bugsnag from '@bugsnag/js';
import { getCsrfToken } from '@99designs/browser';
import { UserRole } from '../common/types';

export type CreateAccountUserRole = UserRole | undefined;
type CreateAccountActionPayload = {
    role: CreateAccountUserRole;
    source?: string;
    marketing_opted_in?: boolean;
};

type CreateAccountHook = {
    createAccount: (
        payload?: CreateAccountActionPayload
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) => Promise<void | { status: number; body: any }>;
    loading: boolean;
    serverError: string;
};

export function useCreateAccount(target: string): CreateAccountHook {
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState<string>('');

    const createAccount = useCallback((payload: CreateAccountActionPayload) => {
        setLoading(true);
        setServerError('');

        return fetch(`/sso/vistaprint/xhr/create-account`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
                csrf_token: getCsrfToken(),
                ...payload,
            }),
        })
            .then((response) => response.json().then((d) => ({ status: response.status, body: d })))
            .then((d) => {
                setLoading(false);
                if (d.status === 200) {
                    if (d.body.target) {
                        window.location.assign(d.body.target);
                    } else {
                        window.location.assign(target);
                    }
                } else if (d.body.error) {
                    setServerError(d.body.error);
                }
                return d;
            })
            .catch((e) => {
                setLoading(false);
                setServerError('internal-server-error');
                Bugsnag.notify(e, (event) => {
                    event.context = 'SSO Action';
                });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { createAccount, loading, serverError };
}
